import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import cx from "classnames";
import styles from "./PromoCodeOptions.module.scss";

import AssetPromoOptionItemA from "assets/images/assetPromoCodeItemA.webp";
// import AssetPromoOptionItemB from "assets/images/BLACK_CUP.png";

const PromoCodeOptions = ({ className, onButtonClick, selectedCode }) => {
  const { cart } = useSelector((s) => s.checkout);
  const appliedCode = cart.discount?.code;

  const [activeButton, setActiveButton] = useState("A");
  const [selectedItemName, setSelectedItemName] = useState(
    promoOptionsData.itemA.itemName,
  );

  // Sync with selectedCode prop (from clicking buttons)
  useEffect(() => {
    if (!selectedCode) {
      setActiveButton(null);
      setSelectedItemName(null);
    } else if (selectedCode === promoOptionsData.itemA.code) {
      setActiveButton("A");
      setSelectedItemName(promoOptionsData.itemA.itemName);
    }
    // else if (selectedCode === promoOptionsData.itemB.code) {
    //   setActiveButton("B");
    //   setSelectedItemName(promoOptionsData.itemB.itemName);
    // }
    else {
      setActiveButton(null);
      setSelectedItemName(null);
    }
  }, [selectedCode]);

  // Sync with applied discount code from cart
  useEffect(() => {
    if (!appliedCode) return;
    if (appliedCode === promoOptionsData.itemA.code) {
      setActiveButton("A");
      setSelectedItemName(promoOptionsData.itemA.itemName);
    }
    // else if (appliedCode === promoOptionsData.itemB.code) {
    //   setActiveButton("B");
    //   setSelectedItemName(promoOptionsData.itemB.itemName);
    // }
  }, [appliedCode]);

  const handleButtonClick = (buttonId, code, itemName) => {
    setActiveButton(buttonId);
    setSelectedItemName(itemName);
    onButtonClick(code, itemName);
  };

  return (
    <div className={cx(className, styles["gws-promocode-wizard"])}>
      <p>
        {promoOptionsData.wording}
        <span>{selectedItemName ?? promoOptionsData.noActive}</span>
      </p>
      <div className={styles["gws-promocode__items"]}>
        <button
          className={cx({ [styles.active]: activeButton === "A" })}
          onClick={() =>
            handleButtonClick(
              "A",
              promoOptionsData.itemA.code,
              promoOptionsData.itemA.itemName,
            )
          }
        >
          <img
            src={promoOptionsData.itemA.imageURL}
            alt={promoOptionsData.itemA.itemName}
          />
        </button>
        {/* <button
          className={cx({ [styles.active]: activeButton === "B" })}
          onClick={() =>
            handleButtonClick(
              "B",
              promoOptionsData.itemB.code,
              promoOptionsData.itemB.itemName,
            )
          }
        >
          <img
            src={promoOptionsData.itemB.imageURL}
            alt={promoOptionsData.itemB.itemName}
          />
        </button> */}
      </div>
    </div>
  );
};

const promoOptionsData = {
  wording: "Free tote with your first delivery",
  noActive: "None",
  itemA: {
    imageURL: AssetPromoOptionItemA,
    code: "FREETOTE",
    itemName: "Worth £20",
  },
  // itemB: {
  //   imageURL: AssetPromoOptionItemB,
  //   code: "BLACKCUP",
  //   itemName: "Black",
  // },
};

export default PromoCodeOptions;
